import React from 'react';
export default function SuccessIcon(props) {
    return (React.createElement("svg", Object.assign({ width: '24', height: '24', viewBox: '0 0 24 24' }, props),
        React.createElement("circle", { cx: '12', cy: '12', r: '9', fill: '#23880C' }),
        React.createElement("g", { className: 'kal-icon-background', stroke: '#FFF', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' },
            React.createElement("path", { className: 'kal-icon-foreground', d: 'M.5 3.5L4 7M10.75 0L4 7', transform: 'translate(6.5 9)' }))));
}
//# sourceMappingURL=SuccessIcon.js.map